import React from 'react'
import { EditorState, Modifier, Entity } from 'draft-js'
import { createPlugin, pluginUtils } from 'draft-extend'
import { withHandlers, withProps, compose, withState } from 'recompose'
import IconSVG from 'svg-inline-react'
import TetherComponent from 'react-tether'
import onClickOutside from 'react-onclickoutside-decorator'

import linkIconSrc from '!svg-inline!./link.svg'

import './style.styl'

const ENTITY_TYPE = 'LINK'

const addLink = (editorState, pushChange, link) => {
  const selectionState = editorState.getSelection()
  const currentContent = editorState.getCurrentContent()
  const contentState = Modifier.applyEntity(
    currentContent,
    selectionState,
    Entity.create(
      ENTITY_TYPE,
      'MUTABLE',
      {
        href: link,
        target: '_blank'
      }
    )
  )
  pushChange(
    EditorState.push(
      editorState,
      contentState,
      'apply-entity'
    )
  )
}

const LinkInput = (props) => (
  <div className="rich-editor-link-popover drift-form">
    <div className="rich-editor-link-text-preview">
      <span>Add a link to text:</span>
      <p><em>{props.linkText}</em></p>
    </div>
    <input
      className="rich-editor-link-input"
      type="url"
      placeholder="enter url..."
      onChange={props.onInputChange} />
    <button
      onClick={props.onEnter}
      className="drift-button rich-editor-link-button"
    >
      ✔
    </button>
    <button
      onClick={props.onCancel}
      className="drift-button rich-editor-link-button"
    >
      ✖
    </button>
  </div>
)


const LinkButton = (props) =>
  <TetherComponent
    attachment="top left"
    targetAttachment="top center"
    targetOffset="0 10px"
    constraints={[{ to: 'scrollParent', attachment: 'together' }]}
  >
    <div className="rich-editor-link-button-container">
      <div className="rich-editor-toolbar-button rich-editor-link-button" onClick={props.toggleOpen}>
        <IconSVG src={linkIconSrc}/>
      </div>
      {props.popoverOpen &&
        <LinkInput {...props} />
      }
    </div>
  </TetherComponent>


const LinkButtonContainer = compose(
  withState('popoverOpen', 'setPopoverOpen', false),
  withState('linkedURL', 'setLinkedURL', undefined),
  withHandlers({
    onCancel: props => () => {
      props.setPopoverOpen(false)
      props.setLinkedURL(undefined)
    },
    onEnter: props => () => {
      addLink(props.editorState, props.onChange, props.linkedURL)
      props.setPopoverOpen(false)
      props.setLinkedURL(undefined)
    },
    toggleOpen: props => () => {
      props.setPopoverOpen(!props.popoverOpen)
    },
    onInputChange: props => (evt) => {
      props.setLinkedURL(evt.target.value)
    },
    onClickOutside: props => () => {
      props.setPopoverOpen(false)
      props.setLinkedURL(undefined)
    },
  }),
  withProps(props => {
    const editorContent = props.editorState.getCurrentContent()
    const selection = props.editorState.getSelection()
    const selectedBlock = editorContent.getBlockForKey(selection.getAnchorKey())
    return {
      linkText: selectedBlock.getText().slice(selection.getAnchorOffset(), selection.getEndOffset())
    }
  }),
  onClickOutside,
)(LinkButton)

// TODO: maybe consider more protocols
const startsWithProtocol = (link) => ['http', 'https', 'tel', 'tcp', 'file', 'mailto'].some(protocol => link && link.startsWith(protocol))
// ref: https://en.wikipedia.org/wiki/Wikipedia:Protocol-relative_URL
const isProtocolRelative = (link) => link && link.startsWith('//')

const LinkDecorator = {
  strategy: pluginUtils.entityStrategy(ENTITY_TYPE),
  component: (props) => {
    const entity = Entity.get(props.entityKey)
    const { href, target } = entity.getData()
    return (
      <a href={!!href && (startsWithProtocol(href) || isProtocolRelative(href)) ? href : `http://${href}`} target={target}>
        {props.children}
      </a>
    )
  }
}

const htmlToEntity = (nodeName, node) => {
  if (nodeName === 'a') {
    return Entity.create(
      ENTITY_TYPE,
      'MUTABLE',
      {
        href: node.getAttribute('href'),
        target: node.getAttribute('target')
      }
    )
  }
}

const entityToHTML = (entity, originalText) => {
  if (entity.type === ENTITY_TYPE) {
    return `<a href="${entity.data.href}" target="${entity.data.target}">${originalText}</a>`
  }
  return originalText
}

export default createPlugin({
  displayName: 'LinkPlugin',
  buttons: LinkButtonContainer,
  decorators: LinkDecorator,
  htmlToEntity,
  entityToHTML,
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Editor/plugins/link/index.js